/**
 * Blendet die Bilder der Produktgalerie weich auf, sobald sie geladen sind.
 *
 * Ein Bild, das noch unterwegs ist, erscheint sonst schlagartig, Zeile fuer
 * Zeile oder als ganzer Block - je nach Verbindung. Hier bleibt seine Flaeche
 * leer, bis das Bild vollstaendig da ist, und blendet dann in einem ruhigen
 * Zug auf (siehe "Bildblende" in divineprint.css).
 *
 * Wichtig ist der Unterschied zwischen wartenden und fertigen Bildern: Was
 * beim Start des Skripts schon geladen ist - etwa aus dem Zwischenspeicher
 * beim zweiten Besuch -, wird gar nicht erst angefasst. Es stuende sonst
 * grundlos einen Moment unsichtbar da und blinkte beim Aufblenden.
 *
 * Kann ein Bild nicht geladen werden, blendet die Flaeche ebenfalls auf -
 * dann zeigt sie eben den Ersatz des Browsers statt fuer immer leer zu
 * bleiben.
 *
 * Die Galerie wird beobachtet: beim Variantenwechsel ersetzt Horizon ihren
 * Inhalt, und auch die neuen Bilder sollen aufblenden statt aufzuschlagen.
 */

/** @param {HTMLImageElement} bild */
function ruesteBild(bild) {
  if (bild.dataset.dpBlende !== undefined) return;
  bild.dataset.dpBlende = '';

  // Schon da - nicht anfassen, sonst blinkt es.
  if (bild.complete) return;

  bild.classList.add('dp-blende');

  const zeige = () => bild.classList.add('dp-blende--da');
  bild.addEventListener('load', zeige, { once: true });
  bild.addEventListener('error', zeige, { once: true });
}

function starte() {
  // Wer reduzierte Bewegung wuenscht, sieht die Bilder wie bisher sofort.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  for (const galerie of document.querySelectorAll('media-gallery')) {
    for (const bild of galerie.querySelectorAll('.product-media img')) {
      ruesteBild(bild);
    }

    if (galerie.dataset.dpBlendeBeobachtet !== undefined) continue;
    galerie.dataset.dpBlendeBeobachtet = '';

    new MutationObserver((eintraege) => {
      for (const eintrag of eintraege) {
        for (const knoten of eintrag.addedNodes) {
          if (!(knoten instanceof Element)) continue;
          if (knoten instanceof HTMLImageElement) ruesteBild(knoten);
          for (const bild of knoten.querySelectorAll?.('img') || []) ruesteBild(bild);
        }
      }
    }).observe(galerie, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', starte, { once: true });
} else {
  starte();
}
